var _style, _path, _path2, _path3, _path4, _path5, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 671 237",
    style: {
      enableBackground: "new 0 0 671 237"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_2_);stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_3_);stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:url(#SVGID_4_);stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_5_);stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:#E73737;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.0699,
    y1: 414.4913,
    x2: 584.3157,
    y2: 414.4913,
    gradientTransform: "matrix(1 0 0 -1 0 561.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF1917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    style: {
      stopColor: "#C62522"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#D82E2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    style: {
      stopColor: "#E33331"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E73533"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M574.7,79.5c-9.1,16.8-14.1,34.1-15.8,52.4c-2.5,26.4,3,50.2,21.9,69.8c5.2,5.4,4.8,6.8-2.7,8.5 c-20.9,4.9-42,4.9-63.1,1.7c-17-2.6-33-4.1-49.9-7.4c-2.1-0.4-3.6-1.1-7-2.4c2.3-2,1.9-6,3.3-6.4c14.1-4.8,68.9-9.8,67.4-19 c-3.2-18.8-2.2-37.6-4.3-56.5c-1-9,0.1-18.4,0.6-27.5c0.3-5.4-7-8.2-0.6-8.6C537.7,83.3,560.6,81.2,574.7,79.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.21,
    y1: 414.4048,
    x2: 214.64,
    y2: 414.4048,
    gradientTransform: "matrix(1 0 0 -1 0 561.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E73533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3048,
    style: {
      stopColor: "#E33331"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5552,
    style: {
      stopColor: "#D82E2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7854,
    style: {
      stopColor: "#C62522"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AF1917"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,79.8c13.7,1.6,33.9,4.3,48.3,6.6c2.1,0.3-0.6,4-0.5,6.9c0.5,13.3,1.2,26.7-0.1,39.9 c-1.4,14.6-1.7,27.1-4.5,41.6c-1.8,9.2,1.5,6.3,10.7,7.2c5.4,0.6,42.1,8.4,56.2,13.3c1.9,0.6,3.5,2.1,5.2,3.2 c-0.1,0.8-0.1,1.5-0.2,2.3c-8.5,2.1-17,4.6-25.7,6.3c-27.9,5.2-55.9,9.5-84.3,5.1c-5.5-0.9-10.8-3.1-16.2-4.7 c2.9-4.2,5.6-8.5,8.8-12.5c19.2-23.9,19.7-51.2,13.7-79.3C108.1,103.4,103.2,91.7,99.3,79.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.29,
    y1: 377.0362,
    x2: 215.8313,
    y2: 377.0362,
    gradientTransform: "matrix(1 0 0 -1 0 561.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF1917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3389,
    style: {
      stopColor: "#B11B18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5749,
    style: {
      stopColor: "#BA1F1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#CA2723"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9654,
    style: {
      stopColor: "#E23230"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E73533"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.3,185.7c0,0,62.8,2.8,69.2,15.1c0,0,3-1.1,0.2-24.6C211.9,152.7,145.3,185.7,145.3,185.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 456.6887,
    y1: 375.7682,
    x2: 528.61,
    y2: 375.7682,
    gradientTransform: "matrix(1 0 0 -1 0 561.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E73533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0346,
    style: {
      stopColor: "#E23230"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#CA2723"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4251,
    style: {
      stopColor: "#BA1F1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6611,
    style: {
      stopColor: "#B11B18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AF1917"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M528.6,185.7c0,0-64.2,4.1-70.5,16.5c0,0-3-1.1-0.2-24.6S528.6,185.7,528.6,185.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.512,
    y1: 457.5516,
    x2: 531.2332,
    y2: 457.5516,
    gradientTransform: "matrix(1 0 0 -1 0 561.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51A19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    style: {
      stopColor: "#DC2E2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3082,
    style: {
      stopColor: "#E73738"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    style: {
      stopColor: "#E7393B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4786,
    style: {
      stopColor: "#E83E45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    style: {
      stopColor: "#E8414A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5574,
    style: {
      stopColor: "#E83E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    style: {
      stopColor: "#E7383A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#E73635"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C51718"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M326.9,21.4c52.7-2.3,104.9,1.2,156.6,12.3c9,1.9,17.9,4.4,26.7,7.1c11.8,3.6,16.5,9.9,16.3,22.5 c-0.3,17.7-2.3,35.4-1.5,53.1c0.8,19,3.6,37.9,6,56.8c1.5,11.8-1.4,14.7-12.9,13.2c-31.9-4-63.9-7.8-95.9-11.1 c-42-4.2-84.1-6.3-126.2-3.2c-39.4,2.9-78.8,7-118.2,10.6c-9.2,0.9-18.3,2.5-27.4,3.1c-9.1,0.6-12.2-3.2-10.3-12.3 c5.8-27,7.2-54.2,6-81.7c-0.4-8.7-1-17.4-1.8-26.1c-1.2-13.6,3-20.6,16.3-25c23-7.5,46.4-13.4,70.6-15.2 C263,23.3,326.9,20.7,326.9,21.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 121.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -83.5918 66.028)",
    className: "st5",
    width: 25.6,
    height: 25.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 620.6,
    y: 121.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 90.8271 487.1132)",
    className: "st5",
    width: 25.6,
    height: 25.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.2063ba98c40a82261f0e2ba94c937341.svg";
export { ForwardRef as ReactComponent };